import {EpicRequestConfig} from '@epic-node-services/public-axios';

export * from './account/utils/AccountTypes';
export * from './affiliate/types';
export * from './analyticsData/utils/AnalyticsDataTypes';
export * from './catalog/utils/CatalogUtils';
export * from './codeRedemption/utils/CodeRedemptionTypes';
export * from './constants/ServiceErrors';
export * from './eula/utils/EulaMarkdownUtils';
export * from './eula/utils/EulaUtils';
export * from './links/types';
export * from './mod';
export * from './product/types';
export * from './receipt/types';
export * from './review/utils/ReviewTypes';
export * from './utils/ErrorUtils';
export * from './utils/ServiceUtils';
export * from './utils/ValidationUtils';
export * from './utils/errors/GeneralServiceError';
export * from './utils/errors/ValidationError';
export * from './validations/types';

export interface EnvConfig {
    [key: string]: string;
}

export enum OAuthTokenType {
    eg1 = 'eg1'
}

export interface ListResponse<E> {
    elements: E[];
    paging: {
        total: number;
        count: number;
        start: number;
    };
}

export interface ListParams {
    sortBy?: string;
    sortDir?: 'DESC' | 'ASC';
    start?: number;
    count?: number;
}

export const defaultAccountOptions: EpicRequestConfig = {
    includeOAuthAccountToken: true
};

export const defaultClientOptions: EpicRequestConfig = {
    includeOAuthClientToken: true
};
